module.exports = __webpack_public_path__ + "img/glasgow-city-council-logo.8d400504.jpg";